"use client";

import createIcon from './util/createIcon';
export default createIcon('M5.26 11H18.74L18.07 20H5.93L5.26 11M9 4H14.97L19 7.38L20.59 5.79L22 7.21L19.21 10H4.79L2 7.21L3.41 5.8L5 7.38L9 4Z', 'FoodTakeoutBox');